import  Container from 'react-bootstrap/Container'
import  Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function InfoPage(props){
    return(<>
        <Container>
            <Row>
                <Col>
            <div className='conclude'>
                The contest has concluded. Winners will be announced shortly, so stay tuned! Thank you for your active participation, and be sure to watch out for more exciting events and updates in the near future.
        </div>
        </Col>
        </Row>
        </Container>
        </>
    );
}